import React from "react";
import { postBarringAction } from "_models/redux/resuqest-barring-action/action";
import { connect } from "react-redux";
import { LoadingButton } from "@mui/lab";
import ModalCustomActions from "modules/support/my-tickets/flow/detailTickets/components/actions-tickets/modalCustom";
import { cleanBarringAction } from "_models/redux/resuqest-barring-action/clean-action";
import { ActionBarringHook } from "../../hooks/actionsTicketsHooks/actionBarringHook";

export const ActionBarring = (props) => {
    const {
        modalOpen,
        setModalOpen,
        handleClickBarring,
        isLoading,
        setIsLoading,
        alert,
        setAlert,
        errorMssge,
        setErrorMssge,
        severityAlert,
        setSeverityAlert,
        handleSubmit,
        clearFunction,
    } = ActionBarringHook(props);

    return (
        <div>
            <LoadingButton
                fullWidth
                size="small"
                onClick={handleClickBarring}
                variant="outlined"
                className="button"
            >
                <h4>Suspender tráfico saliente (Barring)</h4>
            </LoadingButton>
            {modalOpen && (
                <ModalCustomActions
                    modalOpen={modalOpen}
                    setOpenModal={setModalOpen}
                    titleModal="Actualizar Barring"
                    subTitleModal="¿Desea actualizar Barring?"
                    actionRequest={handleSubmit}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    alert={alert}
                    setAlert={setAlert}
                    errorMssge={errorMssge}
                    setErrorMssge={setErrorMssge}
                    severityAlert={severityAlert}
                    setSeverityAlert={setSeverityAlert}
                    clearFunction={clearFunction}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    actionPostBarringAction: state.actionPostBarringAction,
});
const mapDispatchToProps = {
    postBarringAction,
    cleanBarringAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionBarring);
